import { IClickInfo } from "@faire/web-api/indigofair/data/IClickInfo";
import { IMerchandisedCollectionV2Response } from "@faire/web-api/indigofair/merchandised_collections/IMerchandisedCollectionV2Response";
import React from "react";
import styled from "styled-components";

import { TrackedLinkContext } from "@faire/retailer/components/TrackedLink";

import { ItemListSection } from "./ItemListSection";

export const Content: React.FC<Content.IProps> = ({
  collection,
  requestId,
}) => {
  return (
    <TrackedLinkContext.Provider
      value={{
        containerName: "merchandised_collections",
        type: getClickInfoType(collection?.type),
        requestId: requestId,
      }}
    >
      <Wrapper>
        {collection?.sections.map((section) => (
          <StyledItemListSection
            key={section.token}
            section={section}
            type={collection?.type}
          />
        ))}
      </Wrapper>
    </TrackedLinkContext.Provider>
  );
};

export namespace Content {
  export interface IProps {
    collection: ICollection | undefined;
    requestId: string | undefined;
  }

  export interface ICollection {
    type:
      | keyof typeof IMerchandisedCollectionV2Response.IMerchandisedCollectionV2.Type
      | undefined;
    sections: IMerchandisedCollectionV2Response.ISection[];
  }
}

const getClickInfoType = (
  type?: keyof typeof IMerchandisedCollectionV2Response.IMerchandisedCollectionV2.Type
): IClickInfo.Type => {
  switch (type) {
    case IMerchandisedCollectionV2Response.IMerchandisedCollectionV2.Type.BRAND:
      return IClickInfo.Type.BRAND;
    case IMerchandisedCollectionV2Response.IMerchandisedCollectionV2.Type
      .PRODUCT:
      return IClickInfo.Type.PRODUCT;
    default:
      return IClickInfo.Type.PRODUCT;
  }
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  padding: 0 16px;
  max-width: 1280px;
  width: 100%;
  margin: 0;
`;

const StyledItemListSection = styled(ItemListSection)`
  margin: 20px 0;
`;
